import React from 'react';
import appicon from '../resources/appicon.png';

class Heading extends React.Component {
  render() {
    return (
      <nav class="navbar navbar-expand-lg navbar-light navbar-background-custom px-5">
          <img style={{maxHeight: "64px"}} src={appicon} alt="Coronavirus particle with stop sign signalling stop the spread." class="img-responsive"></img>
          <span class="navbar-brand mx-3">COVID-R Risk Assessment</span>
      </nav>
    );
  }  
}

export default Heading;
